import React from 'react';
import QRCode from 'qrcode';
import { urlForPath, ticketScannerPath } from '../../../../../../routes';
import { useAsyncValue } from '../../../../../../model/data';
import { Spinner } from '../../../../../../components/Spinner/Spinner';
import { t } from '../../../../../../locales/translate';

interface Props {
  eventId: string;
  scannerName: string;
}

export function ScannerNameQR(props: Props): JSX.Element {
  const scanUrl = urlForPath(ticketScannerPath(props));

  const [scannerQR, loading, error] = useAsyncValue(async () => {
    return QRCode.toDataURL(scanUrl);
  }, [props.eventId]);

  if (loading) {
    return <Spinner text={t.model.scanner.loadingQR} color="var(--color-tint)" />;
  } else if (error || !scannerQR) {
    return <p>{t.model.scanner.errorQR}</p>;
  }
  return (
    <a href={scanUrl} target="_blank" rel="noreferrer">
      <img src={scannerQR} className="ticket-scanner__event-code" alt={scanUrl} />
    </a>
  );
}
